





























































import { AuthStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import moment from 'moment';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import {  ChatbotConversation, ChatbotConversationStatus, ChatbotMsg, ChatbotMsgsForConversationRes } from '../models/ChatbotMsg';
import ChatbotMessage from './ChatbotMessage.vue';
import { ChatbotServices } from '../api/ChatbotServices';
import { addItemToLocalStorage, ColorsList, getCurrentTimestamp, getItemFromLocalStorage, getItemFromLocalStorageParsed, getUniqueId, ID, removeItemFromLocalStorage, StoregeKey } from '../../core/utils';
import { dateTypes } from '../../core/models';
import LoadingIndicator from '../../core/components/LoadingIndicator.vue';
import ChatbotClearMessagesDialog from './ChatbotClearMessagesDialog.vue';
import ChatbotCloseArrow from './ChatbotCloseArrow.vue';
import ChatbotPreviousMessages from './ChatbotPreviousMessages.vue';
import ChatbotConversationStatusIndicator from './ChatbotConversationStatusIndicator.vue';
import { Destroyed } from '../../core/decorators';
import { ChatbotConversationStatusEnum, ChatbotProperties, chatbotProperties, ChatConversationStatus, MessageType } from '../models/ChatConstants';
import Axios, { CancelTokenSource } from 'axios';

@Component({
    components: {
      ChatbotMessage,
      LoadingIndicator,
      ChatbotClearMessagesDialog,
      ChatbotCloseArrow,
      ChatbotPreviousMessages,
      ChatbotConversationStatusIndicator
    }
})
export default class ChatbotConversationEl extends Mixins(
  RootStoreHelper, 
  AuthStoreHelper,
  NotificationStoreHelper
) {

    loadingText: string = 'Cargando conversaciones...'
    loadingTextColor: string = ColorsList.white;
    loadingColor: string = ColorsList.white;
    showConfirmDeleteHistory: boolean = false;
    conversationId: ID = -1;
    chatProperties: ChatbotProperties = chatbotProperties;
    showStatusAlert: boolean = true;
    conversationStatusToken: CancelTokenSource | null = null;
    getConversationsToken: CancelTokenSource | null = null;
    scrollIsOnTop: boolean = false;
    scrollLock: boolean = false;
    beforeMsgId: ID = -1;
    scrollToFirstMessage: boolean = false;

    changeScrollBehavior(scrollToFirstMessage: boolean){
      this.scrollToFirstMessage = scrollToFirstMessage;

      setTimeout(() => {
        this.scrollToFirstMessage = false;
      }, 2000);
    }

    get getChatMessages(): ChatbotMsg[]{
      return this.$store.state.chatbotState.messages
    }

    get isPendingMessages(): boolean{
      return this.$_getChatbotPendingMsgsForConversation
    }


    handleScrollInConversation() {
      let self = this;
      const container:any = this.$refs.chatbotConversationRef;

      if (!container || this.scrollLock) return;


      // Bloquea los cambios rápidos de estado
      this.scrollLock = true;

      // Timeout para evitar cambios de estado innecesarios
      setTimeout(() => {
          const isScrollOnTop = container.scrollTop === 0;

          // Solo actualiza si hay un cambio real en el estado
          if (this.scrollIsOnTop !== isScrollOnTop) {
            this.scrollIsOnTop = isScrollOnTop;
            // this.beforeMsgId = self.getChatMessages[self.conversationId][0].id;
          }

          this.scrollLock = false; // Libera el bloqueo
        }, 100); // Ajusta el tiempo si es necesario
    }


    @Watch('isPendingMessages', {deep: true})
    onPendingMsgs(value){
      if(!value){
        this.updateScrollPosition();
      }
    }
    @Watch('$_getChatbotConversations', {deep: true, immediate: true})
    onChatConversationsChange(value){
      if(value.length == 0){
        this.getConversations();
        return
      }
    }

    get currentConversationIsWithStatusDisabled(){
      if(this.$_getChatbotPendingConversationStatus.length == 0) return false
      return this.$_getChatbotPendingConversationStatus.includes(this.conversationId)
    }

    @Watch('currentConversationIsWithStatusDisabled', {deep: true, immediate: true})
    onCurrentConversationIsWithStatusDisabled(conversationIsDisabled: boolean){
      if(!conversationIsDisabled){
        this.$_chatbotPendingMsgsForConversation(true)
        this.getMessagesForConversation(this.conversationId)
      }else{
        this.checkConversationStatus(this.conversationId)
      }
    }

    @Watch('getChatMessages', {deep: true, immediate: true})
    onGetChatMessagesChanged(value){
      console.log('onGetChatMessagesChanged', value.length);
      this.updateScrollPosition();
    }

    updateScrollPosition(){
      let scrollToValue = this.scrollToFirstMessage ? 0 : 9999999999999
      let divMessages = this.$refs.chatbotConversationRef as HTMLFormElement;
        if(!divMessages) return
        setTimeout(() => {
          divMessages.scrollTo(0, scrollToValue);
        }, 100);
    }
    created(){
      let savedProperties = getItemFromLocalStorageParsed(StoregeKey.CHAT_PROPERTIES);
      if(savedProperties){
        this.chatProperties = savedProperties
        return
      }

      this.$_chatbotGetProperties(null)
      .then((res) => {
        this.chatProperties = res;
        addItemToLocalStorage(StoregeKey.CHAT_PROPERTIES, res)
      })
    }

    mounted(){
      this.clearHTMLScroll();
      this.clearMessagesInState();
      this.getConversations();
    }

    clearHTMLScroll(){
      if(window.innerWidth < 768){
        document.documentElement.classList.add('overflowYhidden')
      }
    }

    @Destroyed
    removedComponent(){
      this.restoreHTMLScroll();
    }

    restoreHTMLScroll(){
      if(window.innerWidth < 768){
        document.documentElement.classList.remove('overflowYhidden');
      }
    }

    clearMessagesInState(){
      this.$_chatbotClearMessages();
    }

   
    getConversations(){
      let savedConversations = getItemFromLocalStorageParsed(StoregeKey.CHAT_CONVERSATIONS);
      if(savedConversations){
        this.$_chatbotSetConversations(savedConversations);
        let idConversation = savedConversations[0].id;
        this.conversationId = idConversation;
        this.checkConversationStatus(this.conversationId)
        return
      }

      this.cancelGetConversations();
      this.getConversationsToken = Axios.CancelToken.source()
      
      this.$_chatbotGetConversations(this.getConversationsToken.token)
      .then((res) => {
        let conversationsList = res;
        this.$_chatbotSetConversations(conversationsList) //guardo la lista de conversaciones en el store
        let userConversationId = res[0].id;
        this.conversationId = userConversationId
        addItemToLocalStorage(StoregeKey.CHAT_CONVERSATIONS, conversationsList)
        this.checkConversationStatus(this.conversationId)
      }).catch((err) => {
        this.$_catchLoadingDialog({
            response: err.response.data || {},
            alternative_msg: 'Error al obtener las conversaciones'
        })
      }).finally(() => {
        this.$_chatbotPendingConversation(false);
      })
    }

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    markConversationAsPending(idConversation: ID, markAsPending: boolean){
      //Si el ID de conversacion esta en la lista this.$_getChatbotPendingConversationStatus esta pendiente

      let currentConversationIsInPendingList = this.$_getChatbotPendingConversationStatus.includes(idConversation);
      if(markAsPending){
        if(!currentConversationIsInPendingList){
          this.$_setPendingConversationsStatus(idConversation);
        }
      }else{
        if(currentConversationIsInPendingList){
          this.$_setPendingConversationsStatus(idConversation)
        }
        this.showStatusAlert = false
      }
    }

    cancelConversationStatus() {
      if (this.conversationStatusToken) {
        this.conversationStatusToken.cancel();
        this.conversationStatusToken = null;
      }
    }

    cancelGetConversations() {
      if (this.getConversationsToken) {
        this.getConversationsToken.cancel();
        this.getConversationsToken = null;
      }
    }

    @Destroyed
    clean() {
      this.cancelConversationStatus();
      this.cancelGetConversations();
    }

    checkConversationStatus(idConversation: ID, showLoader=true){
      this.cancelConversationStatus();
      /* Compruebo el estado de la conversacion */
      this.$_chatbotPendingConversationStatus({
        conversation_id: idConversation,
        pending: showLoader
      });


      this.conversationStatusToken = Axios.CancelToken.source();
      this.markConversationAsPending(idConversation, true);
      this.$_chatbotGetConversationStatus({ conversationId: idConversation, cancelToken: this.conversationStatusToken.token })
      .then(async (res: ChatbotConversationStatus) => {
        this.$_chatbotSetStatusForConversation({
          conversation_id: idConversation,
          status: res.conversation_status
        })

        if(res.conversation_status == ChatConversationStatus.ENABLED){
          this.markConversationAsPending(idConversation, false);
        }else{
          await this.delay(4000)
          this.checkConversationStatus(idConversation, false)
        }
      }).catch(async (err) => {
        if(Axios.isCancel(err)) return
        if (err && err.response && err.response.data && err.response.data.message) {
            await removeItemFromLocalStorage(StoregeKey.CHAT_CONVERSATIONS);
            this.getConversations();
            return
        }
        this.$_catchLoadingDialog({
            response: err.response.data || {},
            alternative_msg: 'Error al revisar la conversacion...'
        })
        this.getMessagesForConversation(idConversation)
      }).finally(() => {
        this.$_chatbotPendingConversationStatus({
          conversation_id: idConversation,
          pending: false
        });
      })
    }

    getMessagesForConversation(conversationID: ID){
      //busco los mensajes de la primera conversacion
      if(conversationID == -1) return 
      this.setMsgsForConversation(conversationID, [])
      
      let config = {
        conversation_id: conversationID
      }
      this.$_chatbotGetMsgsForConversation(
        config
      ).then((res: ChatbotMsgsForConversationRes) => {
        let refChatPreviousMessages = this.$refs.chatPreviousMessages as HTMLFormElement;
        refChatPreviousMessages.updateNeedToGetPreviousMsgs(res.has_more_previous_messages);
        this.setMsgsForConversation(conversationID, res.messages)
      }).finally(() => {
        this.markConversationAsPending(conversationID, false);
        this.$_chatbotPendingMsgsForConversation(false);
      })
    }

    setMsgsForConversation(conversationID: ID, messages: ChatbotMsg[]){
      let msgs:ChatbotMsg[] = [{
          id: -1,
          conversation_id: getUniqueId(),
          message: `Hola ${this.$_getAuth && this.$_getAuth.username}! 👋 ¿Con qué necesitas ayuda?`,
          message_type: MessageType.BOT,
          timestamp: getCurrentTimestamp(dateTypes.globalFilterDateFormat),
          user: null
      }];

      if(messages && messages.length > 0){
        msgs = messages;
      }
      this.$_chatbotSetMsgsForConversation({
        conversation_id: conversationID,
        messages: msgs || []
      });
    }

    showClearHistoryConfirmation(){
      this.showConfirmDeleteHistory = true;
    }

    clearConversation(){
      /* Borrar toda la conversacion */
      this.$_chatbotClearConversation(this.conversationId)
      .then((res) => {
        removeItemFromLocalStorage(StoregeKey.CHAT_CONVERSATIONS)
        this.$_chatbotClearMessages();
        this.$_chatbotSetConversations([]);
        removeItemFromLocalStorage(StoregeKey.CHAT_CONVERSATIONS);
      }).catch((err) => {
        this.$_catchLoadingDialog({
            response: err.response.data || {},
            alternative_msg: 'Error al borrar la conversación'
        })
      }).finally(() => {
        this.showConfirmDeleteHistory = false;
        this.$_chatbotPendingDeleteConversation(false);
        
      })
    }

    @Emit()
    resendMessageWhenItFails(msg: string){}


    tryAgainMessageWhenItFails(){
      /* Boton intentar de nuevo, cuando falla la respuesta del bot */
      let indexMessageBeforeTryAgain = this.$store.state.chatbotState.messages[this.conversationId].length - 2;
      let lastMsg = this.$store.state.chatbotState.messages[this.conversationId][indexMessageBeforeTryAgain];
      this.resendMessageWhenItFails(lastMsg.message);
    }
}
